export default __webpack_public_path__ + "static/media/cancel.0f5c4004.svg";